import RoomTypeFactory from './roomTypeFactory';

export default class Room {
  constructor(type) {
    this.size = null;
    this.floorNumber;
    this.floorType = null;
    this.wallType = null;
    this.ceilingType = null;
    this.lightingType = null;
    this.heatingType = null;
    this.name = "";
    this.comment = null;
    this.edited = false;

    this.images = [];
    if (!type) {
      this.type = RoomTypeFactory.createInstance('Bedroom');
    }
    else {
      this.type = RoomTypeFactory.createInstance(type);
    }
  }
  addImage(image) {
    this.images.push(image);
  }
}
